import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from 'src/app/core/core.module';
import {Chacra, ChacraGeo, Empresa, IngenieroAgronomoCore, Persona} from 'src/app/chacra-core';
import { selectAllEmpresas } from '../../store/entities/shared/empresas/empresas.selectors';
import { selectAllPersonas } from '../../store/entities/shared/personas/personas.selectors';
import {selectAllChacras} from "../../store/entities/shared/chacras/chacras.selectors";
import {selectAllChacrasGeo} from "../../store/entities/shared/chacras-geo/chacras-geo.selectors";


@Injectable({
  providedIn: 'root'
})
export class SearchService {
  chacras: Chacra[] = [];
  chacrasGeo: ChacraGeo[] = [];
  empresas: Empresa[] = [];
  ingenieros: IngenieroAgronomoCore[] = [];
  personas: Persona[] = [];

  constructor(protected store: Store<AppState>) {

    this.store.pipe(select(selectAllChacras)).subscribe(
      chacras => this.chacras = chacras
    );

    this.store.pipe(select(selectAllChacrasGeo)).subscribe(
      chacrasGeo => this.chacrasGeo = chacrasGeo
    );

    this.store.pipe(select(selectAllEmpresas)).subscribe(
      empresas => this.empresas = empresas
    );

    this.store.pipe(select(selectAllPersonas)).subscribe(
      personas => this.personas = personas
    );
  }

  searchInChacra(searchQuery: string) {
    const sArr = searchQuery.split(':');
    let s = sArr[0];
    let key = null;
    if(sArr[1]){
      key = sArr[0];
      s = sArr[1];
    }

    const searchIndex = this.chacrasGeo
      .map((c: any) => {
        let d = {...c};
        if(d.geometry)
          delete d.geometry;
        return d;
      });

    return this.filterByValue(searchIndex, s, key);
  }

  filterByValue(array, string, key = null) {
    return array.filter(o => {
      let keys = Object.keys(o);
      if(key)
        keys = [key];
      return keys.some(k => (o[k] + '').toLowerCase().includes(string.toLowerCase()));
    });
  }


}
